module.exports = __webpack_public_path__ + "media/phytic-small.1e1d57f3.mp4";